'use client';

import React from 'react';
import { ProductContext } from '@context/ProductProvider';
import createCurrencyString from '@repo/ui/src/functions/currency-functions';
import CallToActionButton from '../CallToActionButton';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import PDPStickyNav from '@repo/ui/src/components/PDPStickyNav';

interface Props {
  name?: string;
  size?: string;
  isTierThree?: boolean;
}

const ProductNav = ({ name, size, isTierThree }: Props) => {
  const { totalPrice, originalPrice, addToCart, isLoadingAddToCart, mainProduct, isLoading } =
    React.useContext(ProductContext);
  const { currency, locale } = useCurrentUrl();
  const hideCTA = isTierThree || mainProduct?.purchasing?.hideCTA || !mainProduct?.purchasing;

  return (
    <PDPStickyNav name={name} size={size} className={hideCTA ? 'py-4' : 'py-2'}>
      {!hideCTA && (
        <div className="flex flex-row text-warm-100 mr-5 items-center gap-x-1 sm:gap-x-2.5">
          {!!Number(totalPrice) && (
            <h6 className="tra-text-web-heading-7 !text-2xl" data-testid="nav-price">
              {createCurrencyString(locale, currency, Number(totalPrice))}
            </h6>
          )}
          {totalPrice !== originalPrice && (
            <h6 className="tra-text-web-heading-7 ml-[14px] line-through">
              {createCurrencyString(locale, currency, Number(originalPrice))}
            </h6>
          )}
        </div>
      )}
      {!hideCTA && mainProduct && !isLoading && (
        <CallToActionButton
          buttonProps={{
            size: 'small',
            disabled: isLoadingAddToCart,
          }}
          buttonProcessing={isLoadingAddToCart}
          processingText=""
          onClickAddToCart={() => addToCart(1)}
          customProductPrice={Number(totalPrice)}
          product={mainProduct}
        />
      )}
    </PDPStickyNav>
  );
};

export default ProductNav;
